import { Navigate, createFileRoute } from "@tanstack/react-router";
import { useAtom } from "jotai/index";

import { isOwner } from "@/lib/auth-predicates";
import RoomsManagementPage from "@/pages/rooms-management-page";
import { meStore } from "@/store/store";

export const Route = createFileRoute("/room-management/")({
  component: Component,
});

function Component() {
  const [me] = useAtom(meStore);

  if (!isOwner(me)) {
    return <Navigate to="/" />;
  }

  return <RoomsManagementPage />;
}
